import { User } from "@/stores/user";
import axios, { AxiosError } from "axios";

const baseUrl: string = "/api/v0/auth";

export interface AuthModel {
    userName: string;
    password: string;
    rememberMe: boolean;
}

export interface AuthResponseModel {
    isAuthenticated: boolean;
    isAdmin: boolean;
    isLockedOut?: boolean;
}

export interface OauthProvider {
    id: string;
    name: string;
}

export interface AuthApi {
    login(model: AuthModel): Promise<AuthResponseModel>;
    oauthProviders(): Promise<OauthProvider[]>;
    logout(): Promise<void>;
    me(): Promise<User | null>;
}

const authApi: AuthApi = {
    login: async (model: AuthModel) => {
        try {
            const { data } = await axios.post<{ auth: AuthResponseModel }>(`${baseUrl}/login`, model, { silent: true });
            return data.auth;
        } catch (ex) {
            if (ex instanceof AxiosError && (ex.response?.status === 400 || ex.response?.status === 401)) {
                const body = ex.response.data as { isLockedOut?: boolean } | undefined;
                return {
                    isAuthenticated: false,
                    isAdmin: false,
                    isLockedOut: body?.isLockedOut ?? false,
                };
            }
            else throw ex;
        }
    },

    oauthProviders: async () => {
        const { data } = await axios.get<OauthProvider[]>(`${baseUrl}/oauth/providers`);
        return data;
    },

    logout: async () => await axios.get(`${baseUrl}/logout`),

    me: async () => {
        const { data } = await axios.get<User | null>(`${baseUrl}/me`);
        return data;
    }
}

export default authApi;